import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../Buttons/Button";
import { rejectOrder } from "../../store/actions/stocks/rejectOrder";

function RejectOrderModal({ open, onClose, order }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.stocks?.rejectPending);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) {
      setReason("");
    }
  }, [open]);

  const handleReject = () => {
    dispatch(
      rejectOrder({
        id: order?.id,
        data: { reason },
        callback: onClose,
      })
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 480,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 2,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{ position: "absolute", top: 19, right: 10 }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full p-3">
          <h1 className="font-semibold text-2xl mb-1">Reject Order</h1>
          <p className="text-sm mb-6 text-[#475467]">
            Provide a reason for rejecting this order.
          </p>

          <label className="text-sm font-[500]">Reason</label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason for rejection"
            rows={4}
            className="w-full border border-[#D0D5DD] rounded-lg p-3 mt-1 mb-6 outline-none resize-none"
          />

          <div className="flex mt-2 w-full items-center">
            <CustomButton
              variant="outlined"
              customColor="#fff"
              children="Cancel"
              width="100%"
              height="44px"
              borderColor="#D0D5DD"
              color="#344054"
              margin="0px 25px 0px 0px"
              onClick={onClose}
            />
            <CustomButton
              variant="contained"
              customColor="#B42318"
              children="Reject"
              width="100%"
              height="44px"
              loading={loading}
              padding="10px"
              color="#fff"
              disabled={!reason?.trim()}
              onClick={handleReject}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default RejectOrderModal;
